
  // Heatmap Analytics Service
  // Handles API calls for heatmap analytics data
 


 //Fetch heatmap analytics data from the API

export const fetchHeatmapAnalytics = async (
  apiUrl = process.env.REACT_APP_API_URL || 'https://devserver.spatialgrid.ai/api/v1'
) => {
  try {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    if (!token) {
      throw new Error('No authentication token found. Please login again.');
    }
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };

    const response = await fetch(
      `${apiUrl}/analytics/heatmap/analytics`,
      {
        method: 'GET',
        headers,
        credentials: 'include', // Include credentials for CORS requests
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('token');
        throw new Error('Session expired. Please login again.');
      }
      throw new Error(`Failed to fetch heatmap analytics: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching heatmap analytics:', error);
    throw error;
  }
};

// Fetch heatmap data for a specific page
 
export const fetchHeatmapDataByPage = async (
  pagePath,
  apiUrl = process.env.REACT_APP_API_URL || 'https://devserver.spatialgrid.ai/api/v1'
) => {
  try {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    if (!token) {
      throw new Error('No authentication token found. Please login again.');
    }
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };

    const response = await fetch(
      `${apiUrl}/analytics/heatmap/page?path=${encodeURIComponent(pagePath)}`,
      {
        method: 'GET',
        headers,
        credentials: 'include',
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('token');
        throw new Error('Session expired. Please login again.');
      }
      throw new Error(`Failed to fetch heatmap data: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching heatmap data by page:', error);
    throw error;
  }
};
